import React from 'react';
import Hero from "./components/biochemistry/Hero";
import Main from "./components/biochemistry/Main";

const BiochemistryPage = () => {
    return (
        <div>
            <Hero />
            <Main />
        </div>
    );
};

export default BiochemistryPage;
